import React from 'react';
import { makeStyles, TextField } from '@material-ui/core';
import { machineParameterNames as params } from '../../Config/constants'

export default function MultipleValueParameter(props) {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <div className={classes.label} style={{ fontWeight: props.param.name === params.vacuümpomp || props.param.name === params.trekrollendruk || props.param.name === params.matrijstemperatuurzones ? "bold" : "medium", fontSize: props.param.name === params.vacuümpomp || props.param.name === params.trekrollendruk || props.param.name === params.matrijstemperatuurzones ? "14px" : "12px" }}>
                {props.param.name}
            </div>
            {props.param.values.map((x, multipleValueIndex) =>
                <div key={'multipleValueIndex_' + multipleValueIndex} className={classes.numberedValue}>
                    <div className={classes.number}>{x.number}</div>
                    <TextField id="outlined-search" label="" variant="outlined" value={x.value} className={classes.numberedTextField} size="small" onChange={(e) => props.parameterChanged(e, props.param.id, x.number)} />
                </div>)}
        </div>
    )
}

const useStyles = makeStyles(() => ({
    container: {
        width: "100%",
        height: "102px"
    },
    numberedTextField: {
        width: "53px",
        backgroundColor: "white",
    },
    numberedValue: {
        float: "left",
        marginRight: "5px",
        marginBottom: "15px",
        marginTop: "15px"

    },
    label: {
        fontFamily: "Lato, sans-serif",
        color: "#000000",
    },
    number: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",

    },
}));